<template>
  <div class="flex flex-col h-screen">
    <ApplicationHeader />
    <main class="flex-1 flex flex-col">
      <RouterView />
    </main>
    <ApplicationFooter />
    <aside class="toast-notifications">
      <ToastComponent
        ref="toastRef"
        :auto-dismiss-timeout="4000"
        :max-visible="null" />
    </aside>
  </div>
</template>

<script setup lang="ts">
import ApplicationHeader from './components/application-header.vue'
import ApplicationFooter from './components/application-footer.vue'
import { ref, h, provide } from 'vue'
import ToastComponent from './components/ui-components/ToastComponent.vue'
import { trackEvent } from './services/gtm'
import { ShowToastType } from './types'

const toastRef = ref<InstanceType<typeof ToastComponent> | null>(null)
function showToast({ variant, headingText, bodyContent, location, isManual = false, isUpload = true, fileType }: ShowToastType) {
  if (toastRef.value) {
    toastRef.value.addNotification({
      variant,
      headingText,
      isManual,
      slots: {
        body: h('div', {
          innerHTML: bodyContent,
        }),
      },
    })
    trackEvent({
      event: 'toastDisplayed',
      toastType: variant,
      location: location,
      messageTitle: headingText,
      category: 'data submission',
      label: isUpload ? 'file submission' : 'text submission',
      action: isUpload ? 'select file' : 'add text',
      fileType: fileType || 'N/A',
    })
  }
}

provide('showToast', showToast)
</script>
